// extracted by mini-css-extract-plugin
export default {"errorFallbackContainer":"ErrorFallback_errorFallbackContainer__LxKJN","errorFallback":"ErrorFallback_errorFallback__0az5Q"};